module.exports = __webpack_public_path__ + "static/media/em-79.2143b042.png";